<template>
  <div class="main-gray-back">
    <van-form @submit="onSubmit">
      <van-divider>基础配置</van-divider>
      <van-field
        v-model="formData.title"
        input-align="right"
        name="配置名称"
        label="配置名称"
        placeholder="配置名称"
        :rules="[{ required: true, message: '请填写配置名称' }]"
      />
      <van-field
        label="选择日期区间"
        readonly
        v-model="formData.data_time"
        placeholder="选择日期区间"
        :rules="[{ required: true, message: '请选择日期区间' }]"
        @click="show = true"
        input-align="right"
      >
      </van-field>

      <van-field
        v-model="formData.complete_count"
        input-align="right"
        name="团队人数"
        label="团队人数"
        placeholder="团队人数"
        :rules="[{ required: true, message: '请填写团队人数' }]"
      />
      <van-field
        v-model="formData.time_limit"
        input-align="right"
        name="购买时限"
        label="购买时限"
        placeholder="购买时限(小时)"
        :rules="[{ required: true, message: '请填写购买时限' }]"
      />
      <van-field name="switch" label="上架状态" input-align="right">
        <template #input>
          <van-switch v-model="formData.status" size="20" />
        </template>
      </van-field>
      <van-field name="switch" label="是否包邮" input-align="right">
        <template #input>
          <van-switch v-model="formData.express_free_status" size="20" />
        </template>
      </van-field>
      <van-divider>地址配置</van-divider>
      <van-field
        input-align="right"
        v-model="formData.express_user_name"
        label="收件人"
        placeholder="请输入姓名"
      />
      <van-field
        input-align="right"
        v-model="formData.express_user_phone"
        label="手机号"
        type="number"
        placeholder="请输入手机"
      />
      <van-field
        input-align="right"
        @click="area_show = true"
        readonly
        :value="
          formData.express_province +
          formData.express_city +
          formData.express_county
        "
        label="地区"
        placeholder="请选择地区"
      />
      <van-field
        input-align="right"
        v-model="formData.address"
        label="详细地址"
        placeholder="请输入详细地址"
      />
      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit"
          >提交</van-button
        >
      </div>
    </van-form>
    <LoginDialog
      :show="loginShow"
      @loginSuccess="loginSuccess"
      @loginCancel="loginCancel"
    />
    <div
      v-show="area_show"
      style="position: fixed; bottom: 0; z-index: 1000; width: 100%"
    >
      <van-popup
        style="top: 50%"
        position="bottom"
        :close-on-click-overlay="false"
        v-model="area_show"
      >
        <van-area
          :area-list="areaList"
          :value="formData.area_key"
          @confirm="areaConfirm"
          @cancel="areaCancel"
        />
      </van-popup>
    </div> 
    <van-calendar v-model="show" type="range" @confirm="onConfirm" />
  </div>
</template>
<style scoped>
.van-cell__value {
  color: #323233 !important;
  
}
.main-gray-back {
  min-height: 100%;
  background: #efefef;
  overflow: scroll;
}
</style>

<script>
import Vue from "vue";
import { Tab, Tabs, Toast, Calendar, Field, Divider, Area } from "vant";
import LoginDialog from "@/components/LoginDialog.vue";
import areaList from "@/utils/area";
Vue.use(Tab)
  .use(Tabs)
  .use(Toast)
  .use(Calendar)
  .use(Field)
  .use(Divider)
  .use(Area);
export default {
  name: "ConfigureAdd",
  components: {
    LoginDialog,
  },
  data: function () {
    return {
      data: "",
      areaList: areaList,
      area_show: false,
      show: false,
      loginShow: false,
      formData: {
        id: 0,
        title: "",
        data_time: "",
        areas: [],
        area_key: "",
        express_user_name: "",
        express_user_phone: "",
        express_province: "",
        express_city: "",
        express_county: "",
        address: "",
        time_range: [],
        complete_count: "",
        time_limit: "",
        auto_complete: true,
        status: true,
        express_free_status: true,
      },
    };
  },
  filter: {},
  mounted() {
    document.title = "销售单配置";
    this.formData.id = parseInt(this.$route.query.id);
    let that = this;
    if(this.formData.id >0){
      that.fetch();
    }
    
  },
  destroyed() {},
  methods: {
    fetch() {
      this.$api.post(
        "/api/jxc/saleDetail",
        { id: this.formData.id },
        (res) => {
          console.log(res); 
          this.formData.title = res.data.title;
          this.formData.data_time = this.timestampToTime(res.data.time_start) + "-" + this.timestampToTime(res.data.time_end);
          this.formData.areas = res.data.areas;
          this.formData.area_key = res.data.area_key;
          this.formData.express_user_name = res.data.express_user_name;
          this.formData.express_user_phone = res.data.express_user_phone;
          this.formData.express_province = res.data.express_province;
          this.formData.express_city = res.data.express_city;
          this.formData.express_county = res.data.express_county;
          this.formData.address = res.data.address;
          this.formData.time_range.push(this.timestampToTime(res.data.time_start))
          this.formData.time_range.push(this.timestampToTime(res.data.time_end))
          this.formData.complete_count = res.data.complete_count;
          this.formData.time_limit = res.data.time_limit;
          this.formData.status = res.data.status == 1 ? true : false;
          this.formData.express_free_status = res.data.express_free_status == 1 ? true : false;

        },
        (err) => {
          Toast.fail(err.msg);
        }
      );
    },
    onSubmit(values) {
      console.log("submit", this.formData);
      let that=this
      this.formData.status = this.formData.status ? 1 : 2;
      this.formData.express_free_status = this.formData.express_free_status
        ? 1
        : 2;
      if (this.formData.id > 0) {
        this.$api.post(
          "/api/jxc/salesEdit",
          this.formData,
          (res) => {
            console.log(res);
            Toast.success("修改成功");
            this.formData.id=res.data.id
            that.fetch() 
          },
          (err) => {
            Toast.fail(err.msg);
          }
        );
      } else {
        this.$api.post(
          "/api/jxc/salesAdd",
          this.formData,
          (res) => {
            console.log(res);
            this.formData.id=res.data.id
            Toast.success("新增成功");
            that.fetch()
          },
          (err) => {
            Toast.fail(err.msg);
          }
        );
      }
    },

    areaConfirm(data) {
      let that = this;
      console.log(data);
      this.formData.areas = [];
      data.map((item, i) => {
        this.formData.areas.push(item.code);
      });
      that.formData.express_province = data[0].name;
      that.formData.express_city = data[1].name;
      that.formData.express_county = data[2].name;
      that.formData.area_key = data[2].code;
      this.area_show = false;
    },
    areaCancel() {
      this.area_show = false;
    },
    formatDate(date) {
      return `${date.getMonth() + 1}/${date.getDate()}`;
    },
    onConfirm(date) {
      // const [start, end] = date;
      const start = datdate.start
      const end = datdate.end
      this.formData.time_range = [];
      let s_time = this.timestampToTime(
        parseInt(start.setHours(0, 0, 0) / 1000)
      );
      let e_time = this.timestampToTime(
        parseInt(end.setHours(23, 59, 59) / 1000)
      );
      this.formData.time_range[0] = s_time;
      this.formData.time_range[1] = e_time;
      this.show = false;
      this.formData.data_time = s_time + "-" + e_time;
    },
    timestampToTime(timestamp) {
      var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000

      let Y = date.getFullYear() + "-";

      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";

      let D = date.getDate() + " ";

      let h = date.getHours() + ":";

      let m = date.getMinutes() ;

      let s = date.getSeconds();

      return Y + M + D + h + m ;
    },
    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log("-------取消登录--------");
    },
  },
};
</script>



// WEBPACK FOOTER //
// ConfigureAdd.vue?9ce06c30